import { render } from "./fee-rate-notice.vue?vue&type=template&id=4426d0c0&scoped=true"
import script from "./fee-rate-notice.vue?vue&type=script&lang=js"
export * from "./fee-rate-notice.vue?vue&type=script&lang=js"

import "./fee-rate-notice.vue?vue&type=style&index=0&id=4426d0c0&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_8f6e2ea806ee27baec234857288b09f4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4426d0c0"]])

export default __exports__